class Util {
    static addClass(el, className) {
        const classList = className.split(' ');
        el.classList.add(...classList);
    }
  
    static removeClass(el, className) {
        const classList = className.split(' ');
        el.classList.remove(...classList);
    }
  
    static toggleClass(el, className, bool) {
        bool ? Util.addClass(el, className) : Util.removeClass(el, className);
    }
  
    static setAttributes(el, attrs) {
        for (const key in attrs) {
            el.setAttribute(key, attrs[key]);
        }
    }
  
    static hasClass(el, className) {
        return el.classList.contains(className);
    }
  
    static getChildrenByClassName(el, className) {
        return Array.from(el.children).filter(child => Util.hasClass(child, className));
    }
  
    static getIndexInArray(array, el) {
        return Array.from(array).indexOf(el);
    }
}
  

export class MultiValueSlider {
    constructor(element) {
        this.element = element;
        this.rangeWrapper = this.element.getElementsByClassName("slider__range");
        this.rangeInput = this.element.getElementsByClassName("slider__input");
        this.value = this.element.getElementsByClassName("js-slider__value");
        this.floatingValue = this.element.getElementsByClassName("js-slider__value--floating");
        this.rangeMin = this.rangeInput[0].getAttribute("min");
        this.rangeMax = this.rangeInput[0].getAttribute("max");
        this.sliderWidth = window.getComputedStyle(this.rangeWrapper[0]).getPropertyValue("width");
        this.thumbWidth = getComputedStyle(this.element).getPropertyValue("--slide-thumb-size");
        this.isInput = this.value[0].tagName.toLowerCase() === "input";
        this.isFloating = this.floatingValue.length > 0;

        if (this.isFloating) {
            this.floatingValueLeft = window.getComputedStyle(this.floatingValue[0]).getPropertyValue("left");
        }

        this.initSlider();
        this.attachEvents();
    }

    initSlider() {
        const inputElement = document.createElement("input");
        inputElement.setAttribute("type", "range");
        
        // Check if range is supported, toggle class if not
        Util.toggleClass(this.element, "slider--range-not-supported", inputElement.type !== "range");

        // Initialize input values
        for (let i = 0; i < this.rangeInput.length; i++) {
            this.updateValue(i);
        }

        this.element.addEventListener("slider-updated", () => {
            for (let i = 0; i < this.value.length; i++) {
                this.updateValue(i);
            }
        });

        this.element.addEventListener("inputRangeLimit", (e) => {
            this.limitRangeValues(e.detail);
        });
    }

    attachEvents() {
        for (let i = 0; i < this.rangeInput.length; i++) {
            this.rangeInput[i].addEventListener("input", () => this.updateValue(i));
            this.rangeInput[i].addEventListener("change", () => this.updateValue(i));
        }

        if (this.isInput) {
            for (let i = 0; i < this.value.length; i++) {
                this.value[i].addEventListener("change", () => this.updateInputValue(i));
            }
        }
    }

    updateValue(index) {
        this.syncInputWithSlider(index);
        this.updateFloatingValue(index);
        this.updateRangeVisual(index);
    }

    syncInputWithSlider(index) {
        if (this.isInput) {
            this.value[index].value = this.rangeInput[index].value;
        } else {
            this.value[index].textContent = this.rangeInput[index].value;
        }
    }

    updateFloatingValue(index) {
        if (this.isFloating) {
            const position = (this.rangeInput[index].value - this.rangeMin) / (this.rangeMax - this.rangeMin);
            this.floatingValue[index].style.left = `calc(0.5 * ${this.floatingValueLeft} + ${position} * (${this.sliderWidth} - ${this.floatingValueLeft}))`;
        }
    }

    updateRangeVisual(index) {
        if (this.rangeInput.length === 1) {
            const percentage = (this.rangeInput[0].value - this.rangeMin) / (this.rangeMax - this.rangeMin) * 100;
            const fill = `calc(${percentage} * (${this.sliderWidth} - 0.5 * ${this.thumbWidth}) / 100)`;
            const empty = `calc(${this.sliderWidth} - ${percentage} * (${this.sliderWidth} - 0.5 * ${this.thumbWidth}) / 100)`;

            this.rangeWrapper[0].style.setProperty("--slider-fill-value", fill);
            this.rangeWrapper[0].style.setProperty("--slider-empty-value", empty);
        }
    }

    limitRangeValues(detail) {
        this.syncInputWithSlider(detail);
        this.updateFloatingValue(detail);
    }

    updateInputValue(index) {
        let value = parseFloat(this.value[index].value);
        if (isNaN(value)) {
            this.value[index].value = this.rangeInput[index].value;
        } else {
            value = Math.max(this.rangeMin, Math.min(value, this.rangeMax));
            this.rangeInput[index].value = value;
            this.rangeInput[index].dispatchEvent(new Event("change"));
        }
    }
}